import React, { Component } from 'react';
import * as validator from 'validator';
import * as utils from '../../utils/utils';

// Mocked utils - Replace with your actual fetch/axios call to your Node.js server
// const utils = {
//   sendRequest: (url, data) => 
//     new Promise((resolve) => setTimeout(() => resolve({ 
//       success: true, 
//       referralCode: Math.random().toString(36).substring(2, 7).toUpperCase(),
//       referralCount: 0 
//     }), 1500))
// };

class WaitlistScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      isSubmitted: false,
      loading: false,
      referralCode: '',
      referralCount: 0,
      copied: false
    };
  }

  componentDidMount() {
    // 1. Check for existing session (Your "Cookie" safety check)
    const savedCode = localStorage.getItem('vibe_referral_code');
    if (savedCode) {
      this.setState({ 
        isSubmitted: true, 
        referralCode: savedCode,
        referralCount: parseInt(localStorage.getItem('vibe_referral_count') || 0)
      });
    }

    // 2. Capture "ref" from URL (e.g., hqvibe.com?ref=ABC)
    const urlParams = new URLSearchParams(window.location.search);
    const refBy = urlParams.get('ref');
    if (refBy) {
      localStorage.setItem('referred_by_id', refBy);
    }
  }

  handleNotifyMe = async (e) => {
    e.preventDefault();
    const { email } = this.state;

    if (!validator.isEmail(email)) {
      alert('Please enter a valid email to start your journey.');
      return;
    }

    this.setState({ loading: true });

    try {
      const referredBy = localStorage.getItem('referred_by_id') || '';
      const response = await utils.sendRequest('/web/signupForDids', { email, referredBy });

      localStorage.setItem('has_signed_up', 'true');
      localStorage.setItem('vibe_referral_code', response.referralCode);
      localStorage.setItem('vibe_referral_count', response.referralCount);

      this.setState({ 
        isSubmitted: true, 
        loading: false, 
        referralCode: response.referralCode,
        referralCount: response.referralCount
      });
    } catch (error) {
      this.setState({ loading: false });
      alert('Something went wrong. Please try again.');
    }
  };

  copyToClipboard = () => {
    const link = `https://hqvibe.com?ref=${this.state.referralCode}`;
    navigator.clipboard.writeText(link);
    this.setState({ copied: true });
    setTimeout(() => this.setState({ copied: false }), 2000);
  };

  render() {
    const { isSubmitted, email, loading, referralCode, referralCount, copied } = this.state;
    const shareLink = `https://hqvibe.com?ref=${referralCode}`;
    const goal = 3;
    const progressPercent = Math.min((referralCount / goal) * 100, 100);

    return (
      <div style={styles.pageWrapper}>
        <style>
          {`
            @keyframes gradientBG { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
            @keyframes float { 0% { transform: translate(0,0); } 50% { transform: translate(15px, -15px); } 100% { transform: translate(0,0); } }
            .glow-orb { position: absolute; border-radius: 50%; filter: blur(100px); z-index: 0; animation: float 10s ease-in-out infinite; }
          `}
        </style>

        {/* The Animated Background Orbs */}
        <div className="glow-orb" style={{ width: '450px', height: '450px', background: 'rgba(99, 102, 241, 0.25)', top: '-10%', left: '-5%' }} />
        <div className="glow-orb" style={{ width: '350px', height: '350px', background: 'rgba(236, 72, 153, 0.18)', bottom: '0%', right: '-5%', animationDelay: '2s' }} />

        <div style={styles.container}>
          {isSubmitted ? (
            /* --- SEXY THANK YOU / REFERRAL DASHBOARD --- */
            <div style={styles.card}>
              <h1 style={styles.title}>You're In. 🎉</h1>
              <p style={styles.subtitle}>
                The journey to a <span style={styles.boldText}>better you</span> starts here. 
                Invite 3 friends to skip the line.
              </p>
              
              <div style={styles.referralCard}>
                <div style={styles.progressHeader}>
                  <span style={styles.progressLabel}>Status: {referralCount >= goal ? 'Beta Unlocked!' : 'Waitlisted'}</span>
                  <span style={styles.progressStats}>{referralCount} / {goal} Joined</span>
                </div>
                
                <div style={styles.progressTrack}>
                  <div style={{...styles.progressBar, width: `${progressPercent}%`}} />
                </div>

                <div style={styles.linkWrapper}>
                  <div style={styles.linkText}>{shareLink}</div>
                  <button onClick={this.copyToClipboard} style={styles.copyBtn}>
                    {copied ? 'COPIED' : 'COPY'}
                  </button>
                </div>
              </div>

              <div style={styles.socialStack}>
                <button 
                  onClick={() => window.open(`https://twitter.com/intent/tweet?text=I'm officially on the waitlist for HQ Vibe! 🚀 Join the movement: &url=${shareLink}`, '_blank')} 
                  style={styles.twitterBtn}
                >
                  Post to Twitter
                </button>
              </div>
            </div>
          ) : (
            /* --- VIBRANT WAITLIST INPUT --- */
            <div style={styles.card}>
              <div style={styles.badge}>Early Access — Be First</div>
              <h1 style={styles.title}>Something Extraordinary Is Coming Soon</h1>
              <p style={styles.subtitle}>
                Be the first to know when we launch. Your journey to a <br/>
                <span style={styles.boldText}>bold, new self-improvement era</span> starts here.
              </p>

              <form onSubmit={this.handleNotifyMe} style={styles.formContainer}>
                <input
                  type="email"
                  placeholder="Enter your email"
                  style={styles.inputField}
                  value={email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  required
                />
                <button type="submit" style={styles.mainButton} disabled={loading}>
                  {loading ? 'Joining...' : 'Notify Me'}
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const styles = {
  pageWrapper: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    backgroundColor: '#0F172A', backgroundImage: 'linear-gradient(-45deg, #0F172A, #1E1B4B, #0F172A, #1e1b4b)',
    backgroundSize: '400% 400%', animation: 'gradientBG 15s ease infinite',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    padding: '20px', position: 'relative', overflow: 'hidden'
  },
  container: { width: '100%', maxWidth: '540px', zIndex: 1 },
  card: { textAlign: 'center', padding: '20px' },
  badge: {
    display: 'inline-block', backgroundColor: '#EC4899', color: '#FFF', padding: '6px 18px',
    borderRadius: '50px', fontSize: '12px', fontWeight: '900', letterSpacing: '1.5px', marginBottom: '24px',
    boxShadow: '0 0 25px rgba(236, 72, 153, 0.4)', textTransform: 'uppercase'
  },
  title: { 
    fontSize: 'clamp(2.4rem, 9vw, 3.8rem)', fontWeight: '900', color: '#F8FAFC', 
    lineHeight: '1.05', marginBottom: '24px', letterSpacing: '-1.5px' 
  },
  subtitle: { fontSize: '1.15rem', color: '#94A3B8', lineHeight: '1.6', marginBottom: '40px' },
  boldText: { color: '#22D3EE', fontWeight: '800', textShadow: '0 0 15px rgba(34, 211, 238, 0.3)' },
  
  // FORM STYLES
  formContainer: { 
    display: 'flex', flexDirection: 'column', gap: '12px', width: '100%',
    padding: '12px', background: 'rgba(255, 255, 255, 0.03)', borderRadius: '24px',
    backdropFilter: 'blur(12px)', border: '1px solid rgba(255, 255, 255, 0.1)'
  },
  inputField: {
    backgroundColor: 'rgba(15, 23, 42, 0.8)', border: '1px solid #334155', borderRadius: '16px',
    padding: '20px', fontSize: '1.05rem', color: '#FFF', outline: 'none'
  },
  mainButton: {
    backgroundColor: '#6366F1', color: '#FFF', border: 'none', borderRadius: '16px',
    padding: '20px', fontSize: '1.1rem', fontWeight: '800', cursor: 'pointer',
    transition: 'transform 0.2s', boxShadow: '0 10px 30px -5px rgba(99, 102, 241, 0.5)'
  },

  // REFERRAL DASHBOARD STYLES
  referralCard: {
    background: 'rgba(255, 255, 255, 0.04)', borderRadius: '28px', padding: '30px',
    border: '1px solid rgba(255, 255, 255, 0.08)', backdropFilter: 'blur(20px)', marginTop: '20px'
  },
  progressHeader: { display: 'flex', justifyContent: 'space-between', marginBottom: '12px' },
  progressLabel: { color: '#F8FAFC', fontWeight: '700', fontSize: '0.9rem' },
  progressStats: { color: '#22D3EE', fontWeight: '800', fontSize: '0.9rem' },
  progressTrack: { height: '10px', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '10px', overflow: 'hidden', marginBottom: '25px' },
  progressBar: { height: '100%', backgroundColor: '#22D3EE', transition: 'width 1.2s cubic-bezier(0.22, 1, 0.36, 1)', boxShadow: '0 0 15px #22D3EE' },
  linkWrapper: { 
    display: 'flex', backgroundColor: 'rgba(0,0,0,0.3)', borderRadius: '14px', 
    border: '1px solid #334155', overflow: 'hidden' 
  },
  linkText: { flex: 1, padding: '14px', color: '#94A3B8', fontSize: '0.85rem', textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden' },
  copyBtn: { 
    backgroundColor: '#6366F1', color: '#FFF', border: 'none', padding: '0 20px', 
    fontWeight: '900', fontSize: '0.75rem', cursor: 'pointer' 
  },
  socialStack: { marginTop: '20px' },
  twitterBtn: {
    width: '100%', padding: '16px', borderRadius: '16px', border: 'none',
    backgroundColor: '#1DA1F2', color: '#FFF', fontWeight: '700', cursor: 'pointer'
  }
};

export default WaitlistScreen;